import { MatTableDataSource, MatPaginator, MatFormFieldModule } from '@angular/material';
import { ConfiguracionesService } from '../../../../../shared/configuraciones.service';
import { Component, ViewChild, OnInit, ViewEncapsulation, ElementRef, Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import {MatDialog,MatDialogRef,MAT_DIALOG_DATA} from '@angular/material/dialog'
import { Router } from '@angular/router';
import { DialogAgregarBarrio } from '../dialogAgregarBarrio/dialogAgregarBarrio.component';
import { DialogEliminarBarrio } from '../dialogEliminarBarrio/dialogEliminarBarrio.component';
import { DialogEditarBarrio } from '../dialogEditarBarrio/dialogEditarBarrio.component';

export interface DialogData {
  id: string;
  barrio: string;
}
@Component({
  selector: 'app-FragmentBarrio',
  templateUrl: './FragmentBarrio.component.html',
  styleUrls: ['./FragmentBarrio.component.scss'],
  encapsulation: ViewEncapsulation.None
})
@Injectable()
export class FragmentBarrio implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public codigo;
  public iscargado = true;
  public ismenu = false;
  bancovalue: string;
  constructor(private route: Router,private configuracionesService: ConfiguracionesService, public toastr: ToastrManager,public dialogEliminar: MatDialog,public dialog: MatDialog,public dialogagregar: MatDialog) {

  
  }



   displayedColumns: string[] = ['id', 'barrio','editar','eliminar'];
   dataSource = new MatTableDataSource();

 
  ngOnInit(): void {

    this.descargarConfiguraciones()
    this.descargarConTipoDoc()  
  
  }

  
  ngAfterViewInit() {

    this.dataSource.paginator = this.paginator;

  }


  descargarConfiguraciones() {

    this.configuracionesService.getBarrios().subscribe(configuraciones => {
  
      this.dataSource.data = configuraciones;

      setTimeout(() => {
        this.iscargado = false;
        this.ismenu = true;
       }, 200);

    
  
    
    });
  }

  descargarConTipoDoc() {

    this.configuracionesService.getConDepartamento().subscribe(tipos => {

      for (let tipo of tipos) {

           this.codigo=tipo.con
      
      
      }  

    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  editar(tipo: any) {
 
    this.dialog.open(DialogEditarBarrio, {
      width: '400px',
      data: {id: tipo.id,
        barrio:tipo.barrio},
    });


  }

  nuevo():void {
    this.dialogagregar.open(DialogAgregarBarrio, {
      width: '400px',
      data: {id: this.codigo},
    
    });
  
  
    }

  deletebanco(tipo: any) {

    this.dialogEliminar.open(DialogEliminarBarrio, {
      width: '350px',
      data: {id: tipo.id,barrio:tipo.barrio},
    });

  }

  
  auditoria():void {

    this.route.navigate(['/AuditoriaBarrios']);
    
  }
  
}
